export const STATUS_COLORS={

    lead_received:{

        background:"#F3F4F6",

        color:"#374151"

    },

    called:{

        background:"#DBEAFE",

        color:"#1D4ED8"

    },

    consent_taken:{

        background:"#F3E8FF",

        color:"#7E22CE"

    },

    punched_in:{

        background:"#FFEDD5",

        color:"#C2410C"

    },

    in_progress:{

        background:"#FEF3C7",

        color:"#B45309"

    },

    approved:{

        background:"#DCFCE7",

        color:"#15803D"

    },

    rejected:{

        background:"#FEE2E2",

        color:"#DC2626"

    }

};